import script from "./info.vue?vue&type=script&setup=true&lang=js"
export * from "./info.vue?vue&type=script&setup=true&lang=js"

import "./info.vue?vue&type=style&index=0&id=f5db86bc&scoped=true&lang=css"

import exportComponent from "D:\\project\\97job-wechat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5db86bc"]])

export default __exports__